// Plug necessary events between new and legacy scripts
import events from "@/bl-events"
import globals from "@/utils/globals"

events.on("authenticate_data_ready", (config) => {
  globals.store.dispatch("setup", config)
})
